import { jsx as o } from "react/jsx-runtime";
import { Container as t, ActiveProgressBar as i } from "./styles.js";
const n = ({ progress: s, height: r = 2, className: a }) => {
  const e = Math.min(Math.max(s, 0), 100);
  return /* @__PURE__ */ o(t, { $height: r, role: "progressbar", "aria-valuenow": e, className: a, children: /* @__PURE__ */ o(i, { $height: r, $progress: e }) });
};
n.displayName = "ProgressBar";
export {
  n as ProgressBar
};
//# sourceMappingURL=ProgressBar.js.map
